export default __webpack_public_path__ + "static/media/head.26e87daa.jpg";